import { createContext, useContext } from "react";

export interface BreadcrumbItem {
  label: string;
  to?: string;
  href?: string;
}

export interface BreadcrumbContextValue {
  breadcrumbs: BreadcrumbItem[] | null;
  setBreadcrumbs: (items: BreadcrumbItem[] | null) => void;
}

export const BreadcrumbContext = createContext<BreadcrumbContextValue | null>(null);

export function useBreadcrumbs(): BreadcrumbContextValue {
  const context = useContext(BreadcrumbContext);
  if (context == null) {
    throw new Error("useBreadcrumbs must be used within BreadcrumbProvider");
  }
  return context;
}
